import { Trigger } from './events';
import { sha256 } from 'js-sha256';

export const sha256Hash: (str: string) => string = (str: string): string => sha256(str);

export const getTrigger: (
	e: React.MouseEvent<any, MouseEvent> | MouseEvent | KeyboardEvent,
) => Trigger = (e: React.MouseEvent<any, MouseEvent> | MouseEvent | KeyboardEvent): Trigger => {
	if (e instanceof KeyboardEvent) {
		return Trigger.RETURN;
	}
	return e.screenX === 0 ? Trigger.RETURN : Trigger.CLICK;
};

export const isNewTab: (
	e: React.MouseEvent<any, MouseEvent> | MouseEvent | KeyboardEvent,
) => boolean = (e: React.MouseEvent<any, MouseEvent> | MouseEvent | KeyboardEvent) => {
	return !!(e && (e.metaKey || e.ctrlKey || e.shiftKey));
};

export const getWordCount: (str: string) => number = (str: string) => {
	return str.length > 0 ? str.split(/\s+/).length : 0;
};
